import React, { useMemo, useRef } from "react"
import Table from "../../../components/Table/Table"
import { useState, useEffect } from "react"
import axios from "axios"
import { Button, LinearProgress, Box, Typography, Divider, IconButton, CircularProgress, Fade } from "@mui/material"
import { Link } from "react-router-dom"
import { useAppDispatch } from "../../../store"
import { setCurrentPage } from "../../../store/auth/authReducer"
import Filter from "../../../components/Filter/Filter"
import { useSelector } from "react-redux"
import { getFilterValues } from "../../../utils/getFilterValues"
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { logOut } from "../../../utils/logOut"
import TranslatedText from "../../../utils/Translate"
import { ContactFilterData } from "../../../components/Filter/FilterData"
import CloseIcon from '@mui/icons-material/Close';
import DownloadDoneIcon from '@mui/icons-material/DownloadDone';
import SimplifiedTable from "../../../components/Table/SimpleTable"
import { useSnackbar } from "../../../utils/SnackbarContext"
import { onChangeContactFilter } from "../../../store/filter/filterReducer"

export default function Contacts() {
    //Declaring states
    const [tableData, setTableData] = useState([])
    const [fileData, setFileData] = useState<any>({
        files: [{
            name: '', size: 0,
            type: '', ufile: ''
        }],
    })
    const [loading, setLoading] = useState(false)
    const [openDialog, setOpenDialog] = React.useState(false);
    const [startRow, setStartRow] = useState(0)
    const [pageRows, setPageRows] = useState(100)
    const [maxRows, setMaxRows] = useState(pageRows)
    const [totalRows, setTotalRows] = useState(0)
    const [totalFileSize, setTotalFileSize] = useState(0)
    const [logState, setLogState] = useState<any>('')
    const [loadingFile, setLoadingFile] = useState(false)

    const { showSnackbar } = useSnackbar();

    function convertFileToBase64(file: any) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = (event: any) => {
                // Извлекаем строку base64 из результата, удаляя префикс "data:...;base64,"
                const base64String = event.target.result.split(',')[1];
                resolve(base64String);
            };
            reader.onerror = (error) => {
                reject(error);
            };
            reader.readAsDataURL(file);
        });
    }

    const [fileNames, setFileNames] = useState<string[]>([]);

    const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
        const files = e.target.files;
        console.log(files);

        if (files && files.length > 0) {
            const newFiles = await Promise.all(
                Array.from(files).map(async (file) => ({
                    name: file.name,
                    size: file.size,
                    type: file.type,
                    ufile: await convertFileToBase64(file),
                }))
            );
            setFileNames(newFiles.map(({ name }) => name));
            setFileData({ ...fileData, files: newFiles })


        } else {
            setFileNames([]);
            setTotalFileSize(0)
            setFileData({ ...fileData, files: [] })
        }
    };

    async function postFilesData(data: any = {}) {
        try {
            setLoadingFile(true)
            const response: any = await fetch(`https://cardgarantsales.com/restapi/loadfile`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                },
                body: JSON.stringify(data)
            });

            if (!response.ok) {
                if (response.status === 401) {
                    logOut(dispatch);
                } else {
                    console.error('Error:', response.statusText);
                    throw new Error(response.statusText);
                }
            } else {
                const reader = response.body.getReader();
                const decoder = new TextDecoder("utf-8");

                let result = '';
                while (true) {
                    const { done, value } = await reader.read();
                    if (done) break;
                    result += decoder.decode(value, { stream: true });
                    console.log(result.trim()); // Вывод текущего состояния полученного ответа
                    // Здесь вы можете обрабатывать текущую часть результата по мере её поступления
                    setLogState(result.trim())

                }
                console.log('Final Result:', result.trim()); // Полный ответ
                setLoadingFile(false)
                // setSnackbarType('success')
                // setOpenSnackbar(true)
            }
        } catch (error: any) {
            // setSnackbarType('error')
            // setOpenSnackbar(true)
            console.log(error);
            if (error.message === "Request failed with status code 401") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }

    const dialogContentRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        // При изменении logState прокручиваем вниз
        if (dialogContentRef.current) {
            dialogContentRef.current.scrollTop = dialogContentRef.current.scrollHeight;
        }
    }, [logState]);



    const handleClickOpenDialog = () => {
        setOpenDialog(true);
    };

    const handleUploadFile = () => {
        postFilesData(fileData)
    };

    const handleDeleteFile = (index: any) => {
        setFileNames(fileNames.filter((el, i) => i != index))
        setFileData({ ...fileData, files: fileData.files.filter((el: any, i: any) => i != index) })
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
        setFileData({
            files: [{
                name: '', size: 0,
                type: '', ufile: ''
            }],
        })
        setFileNames([])
        setLogState('')
    };
    //Set header title
    const dispatch = useAppDispatch()


    useEffect(() => {
        dispatch(setCurrentPage('Contacts'))
    }, [dispatch]);

    const filters = useSelector((state: any) => state.filter.filterUserData.contacts)

    //Making a request to get data for a table
    // async function fetchData(params: object = {}) {
    //     setLoading(true)
    //     try {
    //         const response = await axios.get('https://cardgarantsales.com/restapi/contact', {
    //             headers: {
    //                 'Content-Type': 'application/json',
    //                 "Authorization": "Bearer " + localStorage.getItem('access_token')
    //             },
    //             params: { ...params, startRow, maxRows, calculatetotalcount: true }
    //         })
    //         if (response.data !== null) {
    //             if (typeof (response.data) === 'object') {
    //                 console.log(response.data);
    //                 setTotalRows(+response.data[0].totalcount)
    //                 setTableData(response.data.slice(1))
    //             }
    //             else showSnackbar('ERROR: INVALID SERVER RESPONSE', 'error')
    //         }
    //         setLoading(false)
    //     } catch (error: any) {
    //         console.log(error);
    //         if (error.code === "ERR_BAD_REQUEST") {
    //             logOut(dispatch)
    //         }
    //         else if (error.code === "ERR_NETWORK") {
    //             showSnackbar('ERROR NETWORK', 'error')
    //         }
    //         setLoading(false)
    //     }
    // }

    // Making a request to get data for a table or download a file
    async function fetchData(params: any = {}) {
        setLoading(true)

        let downloadFile: boolean = Boolean((params['downloadcsv'] && params['downloadcsv'] != '0'))

        if (!downloadFile) {
            params = { ...params, calculatetotalcount: true }
        }

        try {
            const response = await axios.get('https://cardgarantsales.com/restapi/contact', {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                },
                params: { ...params, startRow, maxRows },
                responseType: downloadFile ? 'blob' : 'json'
            })

            if (downloadFile) {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'report.zip');
                document.body.appendChild(link);
                link.click();
                link.remove();
            } else if (response.data !== null) {
                if (typeof (response.data) === 'object') {
                    setTotalRows(+response.data[0].totalcount);
                    setTableData(response.data.slice(1));
                } else {
                    showSnackbar('ERROR: INVALID SERVER RESPONSE', 'error');
                }
            }
            setLoading(false);

            if (downloadFile) {
                dispatch(onChangeContactFilter({ type: 'downloadcsv', value: '0' }))
                let updatedFilters = filters.map((el: any) => {
                    if (el.name == 'Download CSV') {
                        return {
                            ...el, params: [{
                                "type": "downloadcsv",
                                "label": "Download CSV",
                                "value": "0",
                                "input": "checkbox"
                            }]
                        }
                    }
                    else return el
                });

                localStorage.setItem(`contacts_filter`, JSON.stringify(updatedFilters));
            }



        } catch (error: any) {
            console.log(error);
            if (error.code === "ERR_BAD_REQUEST") {
                logOut(dispatch);
            } else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
            setLoading(false);
        }
    }
    //on load page send request to get table data with filters
    useEffect(() => {
        fetchData(getFilterValues(filters))
    }, [startRow, maxRows])

    useEffect(() => {
        setMaxRows(pageRows)
        setStartRow(0)
    }, [filters])

    useEffect(() => {
        setTotalFileSize(fileData.files.reduce((accumulator: any, currentObject: any) => {
            return accumulator + currentObject.size;
        }, 0))
    }, [fileNames])

    //Pagination buttons
    function handleBack() {
        if ((startRow - pageRows) < 0) {
            setStartRow(0)
            setMaxRows(pageRows)

        }
        else {
            setStartRow((prev) => prev - pageRows)
            setMaxRows((prev) => prev - pageRows)
        }
    }

    function handleNext() {

        setStartRow((prev) => prev + pageRows)
        setMaxRows((prev) => prev + pageRows)

    }

    function handleEnd() {

        setStartRow(totalRows % pageRows === 0 ? totalRows - pageRows : totalRows - (totalRows % pageRows))
        setMaxRows(totalRows % pageRows === 0 ? totalRows : totalRows - (totalRows % pageRows) + pageRows)

    }

    function handleStart() {

        setStartRow(0)
        setMaxRows(pageRows)

    }

    const accesslevel = useSelector(
        (state: any) => state.auth.authData.accesslevel
    )

    const totalPages = Math.ceil(totalRows / pageRows);
    const currentPage = Math.ceil(maxRows / pageRows);
    //exclusion of unnecessary table renderers
    const memoizedTable = useMemo(() => <SimplifiedTable rows={typeof (tableData) === 'object' ? tableData : []} page={'contact'} />, [tableData]);
    const memoizedFilter = useMemo(() => <Filter exclude={accesslevel !== "5" ? ['partnerbank'] : []} filtersList={ContactFilterData} fetchData={(params: object) => fetchData(params)} page="contacts" />, []);

    return (
        <Box sx={{ height: '86vh', display: 'flex', flexDirection: 'column' }}>
            <Box sx={{ mb: 1 }}>
                <Link to='/contact' state={{ type: 'add' }}>
                    <Button size="small" sx={{ mr: 1 }} variant="outlined"><TranslatedText text={"Add contact"} /></Button>
                </Link>
                <Button onClick={handleClickOpenDialog} size="small" variant="outlined"><TranslatedText text={"Upload contacts"} /></Button>
            </Box>
            {memoizedFilter}
            {loading ? <LinearProgress sx={{ width: "50%", marginTop: '33vh', marginLeft: 'auto', marginRight: 'auto' }} /> :
                <>
                    {memoizedTable}
                    <Fade in={!loading} timeout={300}>
                        <Box sx={{ display: 'flex', alignItems: "center", marginTop: 'auto' }}>
                            <Box sx={{ mt: 2 }}>
                                <Button disabled={startRow === 0} onClick={() => handleStart()} size="small" sx={{ mr: 1 }} variant="outlined" >{"<<"}</Button>
                                <Button disabled={startRow === 0} onClick={() => handleBack()} size="small" sx={{ mr: 1 }} variant="outlined" ><span>{'<'}&nbsp;</span> {<TranslatedText text={"Back"} />}</Button>
                                <Button disabled={maxRows >= totalRows} onClick={() => handleNext()} size="small" sx={{ mr: 1 }} variant="outlined" >{<TranslatedText text={'Next'} />}&nbsp;<span>{'>'}</span></Button>
                                <Button disabled={maxRows >= totalRows || tableData.length < pageRows} onClick={() => handleEnd()} size="small" sx={{ mr: 1 }} variant="outlined" >{">>"}</Button>
                            </Box>
                            <Typography sx={{ pt: 2, ml: 2 }}><TranslatedText text={'Rows on page:'} /> {pageRows}</Typography>
                            <Typography sx={{ pt: 2, ml: 2 }}>
                                <TranslatedText text={'Page:'} /> {currentPage} / {totalPages}
                            </Typography>
                            <Typography sx={{ pt: 2, ml: 2 }}><TranslatedText text={'Total rows:'} /> {totalRows}</Typography>
                        </Box>
                    </Fade>
                </>
            }
            <Dialog open={openDialog} onClose={handleCloseDialog}>
                <DialogTitle><TranslatedText text={'Upload Contacts'} /></DialogTitle>
                {(loadingFile || logState.length != 0) && fileNames.map((name, index) => {
                    return <Box key={index} sx={{ pl: 3, pr: 3, mb: 1 }}>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                            <Typography gutterBottom>
                                {`${name}`}
                            </Typography>
                            {(!loadingFile && logState.length == 0) && <IconButton onClick={() => handleDeleteFile(index)}><CloseIcon color="error" /></IconButton>}
                            {loadingFile && <CircularProgress size={20} />}
                            {(!loadingFile && logState.length != 0) && <Box></Box>}
                        </Box>
                        {/* <Divider /> */}
                    </Box>
                })}
                <DialogContent ref={dialogContentRef} dividers>
                    {(logState.length == 0) && <DialogContentText sx={{ mb: 3 }}>
                        <TranslatedText text={'To upload contacts, select a files and click upload.'} />
                    </DialogContentText>}
                    <Box sx={{ width: '100%', display: "flex", justifyContent: "center", flexDirection: 'column', alignItems: 'center' }}>
                        {logState.length == 0 && <Button
                            sx={{ width: 200, mb: 3 }}
                            variant="outlined"
                            component="label"
                        >
                            <TranslatedText text={'Select Files'} />
                            <input
                                onChange={handleFileChange}
                                type="file"
                                accept=".xlsx"
                                multiple
                                hidden
                            />
                        </Button>}
                        {(fileNames.length > 0 && !loadingFile && logState.length == 0) && fileNames.map((name, index) => {
                            return <Box key={index} sx={{ width: '100%' }}>
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                                    <Typography gutterBottom>
                                        {`${name}`}
                                    </Typography>
                                    {(!loadingFile && logState.length == 0) && <IconButton onClick={() => handleDeleteFile(index)}><CloseIcon color="error" /></IconButton>}
                                    {loadingFile && <CircularProgress size={20} />}
                                    {(!loadingFile && logState.length != 0) && <Box></Box>}
                                </Box>
                                <Divider />
                            </Box>
                        })}

                        <Typography
                            sx={{ width: '100%', fontWeight: 700, fontSize: 14, whiteSpace: 'pre-line' }}
                        >
                            {logState.replace(/<BR>/g, '\n').replace(/<b>Warning<\/b>:[\s\S]*?<\/b><br \/>/g, '').replace(/<br \/>/g, '')}
                        </Typography>

                        {totalFileSize >= 104857600 && <Typography sx={{ mt: 3 }} color={'error'}><TranslatedText text={'The maximum file weight has been exceeded'} /> 100MB</Typography>}
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button disabled={loadingFile} onClick={handleCloseDialog}><TranslatedText text={'Close'} /></Button>
                    {(!loadingFile && logState.length == 0) && <Button disabled={(totalFileSize >= 104857600) || fileNames.length == 0} onClick={handleUploadFile}>
                        <TranslatedText text={'Upload'} /></Button>}
                </DialogActions>
            </Dialog>
        </Box>
    )
}